var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-lg mx-auto"},[_c('LogBookForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }